import { io } from 'socket.io-client';

import socketBaseUrl from './socketBaseUrl';

const socketLoadListings = io(`${socketBaseUrl}/load-listings-progress`, {
  transports: ['websocket'],
  autoConnect: false,
});

export default socketLoadListings;
